<template>
  <div>
    <loader v-if="loader == true"></loader>
    <section id="content">
      <div class="page page-hz-menu-layout">
        <div class="row">
          <div class="col-md-12">
            <section class="tile">
              <div class="tile-header dvd dvd-btm">
                <h1 class="custom-font">
                  <strong>Simulações</strong> de Crédito
                </h1>
                <ul class="controls">
                  <li>
                    <router-link :to="{ name: 'IndexSimulacao' }">
                      <i class="fa fa-plus mr-5"></i> Simulação Terceiro
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'NovaProposta' }"
                      @click="getVersionandAuthSystem()"
                    >
                      <i class="fa fa-plus mr-5"></i> Nova simulação
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="tile-body">
                <div class="row">
                  <div class="col-md-12 table-responsive">
                    <!--                                    <div class="alert alert-warning">-->
                    <!--                                      <p>-->
                    <!--                                        <strong>Atenção!</strong> <br>-->
                    <!--                                        Estamos com uma instabilidade no sistema. Algumas funcionalidades estarão indisponíveis.-->
                    <!--                                      </p>-->
                    <!--                                    </div>-->
                    <table-filter
                      ref="tablePropostas"
                      :api-url="url"
                      :fields="userid != 0 ? fieldsInterno : fieldsInterno"
                      :row-class="onRowClass"
                    >
                      <template slot="status" scope="props">
                        <span
                          v-if="
                            props.rowData.status_id == 1 &&
                            props.rowData.simulacao == true
                          "
                        >
                          Simulação
                        </span>
                        <span
                          v-if="
                            props.rowData.status_id == 1 &&
                            props.rowData.simulacao == false
                          "
                        >
                          Simulação em Análise
                        </span>
                        <span
                          v-if="
                            props.rowData.status_id == 2 ||
                            props.rowData.status_id == 3
                          "
                        >
                          Análise Cadastro
                        </span>
                        <span
                          v-if="
                            props.rowData.status_id >= 4 &&
                            props.rowData.status_id <= 7
                          "
                        >
                          Análise de Crédito
                        </span>
                        <span
                          v-if="
                            props.rowData.status_id == 13 ||
                            props.rowData.status_id == 14 ||
                            props.rowData.status_id == 17
                          "
                        >
                          Análise Cadastro
                        </span>
                        <span v-if="props.rowData.status_id == 10">
                          Aprovada
                        </span>
                        <span v-if="props.rowData.status_id == 12">
                          Contratada
                        </span>
                      </template>
                      <template slot="actions" scope="props">
                        <div class="custom-actions pull-right">
                          <button
                            @click="geraTermo(props.rowData.id)"
                            class="btn btn-greensea btn-xs"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Gerar Termo"
                          >
                            <i class="fa fa-file mr-5"></i>
                          </button>
                          <router-link
                            :to="{
                              name: 'ViewProposta',
                              params: { id: props.rowData.id, origem: 'E' },
                            }"
                            class="btn btn-default btn-xs"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Visualizar Proposta"
                          >
                            <i class="fa fa-eye mr-5"></i>
                          </router-link>
                          <router-link
                            :to="{
                              name: 'EditarProposta',
                              params: { id: props.rowData.id, origem: 'E' },
                            }"
                            v-if="props.rowData.simulacao == true"
                            class="btn btn-primary btn-xs"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Editar Simulação"
                          >
                            <i class="fa fa-edit mr-5"></i>
                          </router-link>
                          <button
                            class="btn btn-danger btn-xs"
                            @click="arquivar(props.rowData.id)"
                            v-if="props.rowData.simulacao == true"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Excluir Simulação"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </template>
                    </table-filter>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <router-link
              :to="{ name: 'NovaProposta' }"
              class="myIcon icon-success novaProposta"
            >
              <i class="fa fa-plus"></i>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <div
      class="modal fade"
      id="modalTermo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none; margin-top: 80px"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            class="modal-header"
            style="background-color: #78b800 !important; color: #fff !important"
          >
            <h4 class="modal-title custom-font">
              Geração de Termo de Compromisso
            </h4>
          </div>
          <div
            class="modal-body"
            id="conteudoDetalhes"
            style="max-height: calc(90vh - 210px); overflow-y: auto"
          >
            <div class="row form-group">
              <div class="col-md-12" v-if="idProposta != null">
                <p><strong>Simulação N°</strong> {{ idProposta }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <label>Conta Corrente</label>
                <select
                  name="conta_id"
                  id="conta_id"
                  class="form-control"
                  v-model="conta.conta_id"
                  required
                >
                  <option v-for="l in listaContas" :value="l.id" :key="l.id">
                    {{ l.conta }} - {{ l.descricao }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row" v-if="listaContas.length == 0">
              <div class="col-md-12">
                <div class="alert alert-danger">
                  <p>
                    <strong>Atenção</strong> Não existem contas cadastradas para
                    seu usuário. Acesse o módulo de confirgurações e realize o
                    cadastro da conta.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-md-12 text-left">
              <button
                class="btn btn-success"
                @click="geraDocTermo()"
                id="saveTermo"
                :disabled="conta.conta_id == '' || !conta.conta_id"
              >
                Gerar Termo
              </button>
              <button class="btn btn-lightred" data-dismiss="modal">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalAction"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none; margin-top: 80px"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            class="modal-header"
            style="background-color: #78b800 !important; color: #fff !important"
          >
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" style="color: #fff !important"
                >&times;</span
              >
            </button>
            <h4 class="modal-title custom-font">
              Simulação N° {{ proposta.id }}
            </h4>
          </div>
          <div
            class="modal-body"
            style="max-height: calc(90vh - 210px); overflow-y: auto"
          >
            <div class="row">
              <div class="col-md-12" align="center">
                <div
                  class="col-xs-6 col-md-3 form-group"
                  style="cursor: pointer; text-align: center !important"
                  @click="fecharModalAction('termo')"
                >
                  <section class="tile-simple">
                    <div class="tile-widget bg-greensea text-center p-30">
                      <i class="fa fa-file fa-3x"></i>
                      <h5><br />Gerar Termo</h5>
                    </div>
                  </section>
                </div>
                <div
                  class="col-xs-6 col-md-3 form-group"
                  style="cursor: pointer; text-align: center !important"
                  @click="fecharModalAction('visualizar')"
                >
                  <section class="tile-simple">
                    <div class="tile-widget bg-greensea text-center p-30">
                      <i class="fa fa-eye fa-3x"></i>
                      <h5><br />Visualizar Simulação</h5>
                    </div>
                  </section>
                </div>
                <div
                  class="col-xs-6 col-md-3 form-group"
                  style="cursor: pointer; text-align: center !important"
                  v-if="proposta.simulacao == true"
                  @click="fecharModalAction('editar')"
                >
                  <section class="tile-simple">
                    <div class="tile-widget bg-greensea text-center p-30">
                      <i class="fa fa-edit fa-3x"></i>
                      <h5><br />Editar Simulação</h5>
                    </div>
                  </section>
                </div>
                <div
                  class="col-xs-6 col-md-3 form-group"
                  style="cursor: pointer; text-align: center !important"
                  v-if="proposta.simulacao == true"
                  @click="fecharModalAction('excluir')"
                >
                  <section class="tile-simple">
                    <div class="tile-widget bg-greensea text-center p-30">
                      <i class="fa fa-trash fa-3x"></i>
                      <h5><br />Excluir Simulação</h5>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderPropostas from "./_header.vue";
import TableFiler from "../../components/tables/Table.vue";
const { API_URL } = process.env;
var fileDownload = require("js-file-download");

export default {
  name: "index-propostas",

  data() {
    return {
      loader: false,
      proposta: {},
      fieldsInterno: [
        {
          name: "id",
          prefix: "id",
          sortField: "id",
          title: "#",
        },
        {
          name: "nome",
          prefix: "pr.nome",
          sortField: "nome",
          title: "Nome",
        },
        {
          name: "lojista",
          prefix: "lj.razao_social",
          sortField: "lojista",
          title: "Lojista",
        },
        {
          name: "cpfcnpj",
          prefix: "pr.cpfcnpj",
          sortField: "cpfcnpj",
          title: "CPF",
        },
        {
          name: "tipo_proposta",
          sortField: "tipo_proposta",
          title: "Tipo Simulação",
          titleClass: "table-hide",
          dataClass: "table-hide",
        },
        {
          name: "valor_proposta",
          sortField: "valor_proposta",
          title: "Valor Simulação R$",
          callback: "formatReal",
          titleClass: "table-hide",
          dataClass: "table-hide",
        },
        {
          name: "__slot:status",
          titleClass: "table-hide",
          dataClass: "table-hide",
          title: "Situação",
        },
        {
          name: "__slot:actions",
          title: "",
          titleClass: "table-hide",
          dataClass: "table-hide",
        },
      ],
      userid: localStorage.userid,
      fields: [
        {
          name: "id",
          prefix: "id",
          sortField: "id",
          title: "#",
        },
        {
          name: "nome",
          prefix: "pr.nome",
          sortField: "nome",
          title: "Nome",
        },
        {
          name: "cpfcnpj",
          prefix: "pr.cpfcnpj",
          sortField: "cpfcnpj",
          title: "CPF",
        },
        {
          name: "tipo_proposta",
          sortField: "tipo_proposta",
          title: "Tipo Simulação",
          titleClass: "table-hide",
          dataClass: "table-hide",
        },
        {
          name: "valor_proposta",
          sortField: "valor_proposta",
          title: "Valor Simulação R$",
          callback: "formatReal",
          titleClass: "table-hide",
          dataClass: "table-hide",
        },
        {
          name: "__slot:status",
          titleClass: "table-hide",
          dataClass: "table-hide",
          title: "Situação",
        },
        {
          name: "__slot:actions",
          title: "",
          titleClass: "table-hide",
          dataClass: "table-hide",
        },
      ],
      url: API_URL + "propostas",
      listaContas: [],
      idProposta: null,
      conta: {},
    };
  },

  components: {
    "header-propostas": HeaderPropostas,
    "table-filter": TableFiler,
  },

  methods: {
    async getVersionandAuthSystem() {
      var $this = this;

      await $this.$http.get("/propostas/versao").then(function (response) {
        if (17 != parseFloat(response.data[0]["versao"])) {
          swal({
            title: "Atenção!",
            text: "Versão do sistema foi atualizada. Por favor pressione as teclas 'Ctrl + F5', para atualizar o cache do navegador",
            type: "error",
            confirmButtonText: "Ok",
          }).then((willDelete) => {
            if (willDelete.value) {
              return $this.$router.push({ path: "/" });
            }
          });
        }
      });
    },
    geraDocTermo: function () {
      var $this = this;
      $("#modalTermo").modal("hide");

      $this.loader = true;
      $this.$http
        .post("/propostas/" + $this.idProposta + "/termo", $this.conta, {
          responseType: "blob",
        })
        .then(function (response) {
          $this.$toastr("success", "Termo gerado com sucesso!");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "TERMO " + $this.idProposta + ".pdf");
          document.body.appendChild(link);
          link.click();

          $this.loader = false;
        })
        .catch(function (error) {
          $("#modalTermo").modal("show");
          $this.loader = false;
        });
    },

    geraTermo: function (id) {
      this.idProposta = id;
      setTimeout(function () {
        $("#modalTermo").modal("show");
      }, 100);
    },

    getlistaContas: function () {
      var $this = this;
      $this.loader = true;

      $this.$http
        .get("/lojista/conta")
        .then(function (response) {
          $this.listaContas = response.data;
          $this.loader = false;
        })
        .catch(function (error) {
          $this.loader = false;
        });
    },

    onRowClass(dataItem) {
      if (dataItem.status_id == 10 || dataItem.status_id == 15) {
        return "alert alert-success";
      }

      if (dataItem.simulacao == true) {
        if (dataItem.aprovacao_automatica == false) {
          return "tr-default";
        } else {
          return "alert alert-cyan";
        }
      } else {
        if (dataItem.aprovacao_automatica == false) {
          return "alert alert-warning";
        } else {
          return "alert alert-cyan";
        }
      }
    },

    arquivar: function (id) {
      var $this = this;
      $this.loader = true;

      swal({
        title: "Atenção",
        text: "Deseja realmente excluir está simulação?",
        type: "warning",
        buttons: true,
        showCancelButton: true,
        dangerMode: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((willDelete) => {
        if (willDelete.value) {
          $this.$http.delete("/propostas/" + id).then(function () {
            $this.$refs.tablePropostas.$refs.vuetable.refresh();
            $this.loader = false;
            swal.close();
          });
        } else {
          $this.loader = false;
          swal.close();
        }
      });
    },

    onRowClicked: function (eventData) {
      this.proposta = eventData;
      $("#modalAction").modal("show");
    },

    fecharModalAction: function (tipo) {
      var $this = this;

      $("#modalAction").modal("hide");

      if (tipo == "termo") {
        return $this.geraTermo($this.proposta.id);
      }

      if (tipo == "editar") {
        return $this.$router.push({
          name: "EditarProposta",
          params: { id: $this.proposta.id, origem: "E" },
        });
      }

      if (tipo == "visualizar") {
        return $this.$router.push({
          name: "ViewProposta",
          params: { id: $this.proposta.id, origem: "E" },
        });
      }

      if (tipo == "excluir") {
        $this.arquivar($this.proposta.id);
      }
    },

    detectar_mobile: function () {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  mounted() {
    this.$events.off("rowClicked");
    if (this.detectar_mobile() == true) {
      this.$events.on("rowClicked", (eventData) =>
        this.onRowClicked(eventData)
      );
    }
    this.getlistaContas();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/propostas/Index.vue